import React from 'react';
import PropTypes from 'prop-types';
import './ListBuilder.scss';
import Select from 'react-select';
import Button from '../Button';

class ListBuilder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownList: [],
            selectedList: [],
            selectedNewItem: null,
            itemsSelectedForRemoval: [],
        };
    }

    componentDidMount() {
        const dropdownList = [];
        const selectedList = [];

        this.props.list.forEach((item) => {
            dropdownList.push({
                id: item.id,
                name: item.name,
                visible: true,
            });

            selectedList.push({
                id: item.id,
                name: item.name,
                visible: false,
            });
        });

        this.setState({ dropdownList, selectedList });
    }

    selectNewItem = (selectedOption) => {
        this.setState({ selectedNewItem: selectedOption });
    };

    addNewItem = (e) => {
        e.preventDefault();
        const { selectedNewItem } = this.state;

        if (selectedNewItem) {
            this.addItem(selectedNewItem);
            this.setState({ selectedNewItem: null });
        }
    };

    addItem = (option) => {
        const dropdownList = [...this.state.dropdownList];
        const selectedList = [...this.state.selectedList];

        const foundIndex = dropdownList.findIndex((x) => x.id === option.id);
        dropdownList[foundIndex].visible = false;

        const foundSelectedIndex = selectedList.findIndex((x) => x.id === option.id);
        selectedList[foundSelectedIndex].visible = true;

        this.setState({ dropdownList, selectedList });
        this.props.addToList(selectedList.filter((obj) => obj.visible === true));
    };

    onSelectChange = (e) => {
        const options = e.target.options;
        const selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.selectedList.find((x) => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ itemsSelectedForRemoval: selected });
    };

    removeSelectedItems = () => {
        const dropdownList = [...this.state.dropdownList];
        const selectedList = [...this.state.selectedList];
        const selectedForRemoval = [...this.state.itemsSelectedForRemoval];

        selectedForRemoval.forEach((item) => {
            const id = item.id;

            const foundIndex = dropdownList.findIndex((x) => x.id === id);
            dropdownList[foundIndex].visible = true;

            const foundSelectedIndex = selectedList.findIndex((x) => x.id === id);
            selectedList[foundSelectedIndex].visible = false;
        });

        this.setState({ dropdownList, selectedList, itemsSelectedForRemoval: [] });
        this.props.addToList(selectedList.filter((obj) => obj.visible === true));
    };

    renderSelectedItems = () => {
        return this.state.selectedList
            .filter((option) => option.visible === true)
            .map((option) => (
                <option key={option.id} value={option.id}>
                    {option.name}
                </option>
            ));
    };

    render() {
        const { dropdownList, selectedNewItem } = this.state;

        return (
            <div className="list-builder">
                <div className="row no-gutters">
                    <div className="col-12 search-field">
                        <div className="input-group">
                            <Select
                                name="locations"
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.name}
                                placeholder={
                                    this.props.selectPlaceholder || "Search for a location to add..."
                                }
                                options={dropdownList.filter((obj) => obj.visible === true)}
                                onChange={this.selectNewItem}
                                value={selectedNewItem}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        flex: '1 1 200px',
                                        minWidth: '200px',
                                        maxWidth: '400px',
                                        width: '100%',
                                    }),
                                }}
                            />
                            <button
                                id="btnAddItem"
                                className="btn btn-outline-secondary"
                                onClick={this.addNewItem}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <span className="has-float-label">
                            <select
                                className="form-control mt-3"
                                multiple
                                size="8"
                                defaultValue={[]}
                                onChange={this.onSelectChange}
                                required
                            >
                                {this.renderSelectedItems()}
                            </select>
                            <label>{this.props.selectLabel}</label>
                        </span>
                        <div className="text-end">
                            <Button
                                type="button"
                                bootstrapClass="btn btn-outline-secondary mt-2"
                                name="btnRemoveItem"
                                text="Remove Selected"
                                onClick={this.removeSelectedItems}
                            />
                        </div>
                        <div className="invalid-feedback">Please select at least one item</div>
                    </div>
                </div>
            </div>
        );
    }
}

ListBuilder.propTypes = {
    list: PropTypes.array.isRequired,
    addToList: PropTypes.func.isRequired,
    selectLabel: PropTypes.string.isRequired,
    selectPlaceholder: PropTypes.string,
};

export default ListBuilder;
